// @ts-ignore
export const httpFetch = (...p) => fetch(...p);
//# sourceMappingURL=fetch-browser.js.map